import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import type { DefaultMatterExpense } from "@/lib/types";
import { copyToClipboard } from "@/lib/utils/copyToClipboard";
import { Clipboard, Copy } from "lucide-react";
import type { ReactNode } from "react";

type MatterDefaultExpenseRowContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  expense: DefaultMatterExpense;
  onDelete: () => void;
  onEdit: () => void;
  trigger: ReactNode;
};

export function MatterDefaultExpenseRowContextMenu({
  canDelete,
  canEdit,
  expense,
  onDelete,
  onEdit,
  trigger,
}: MatterDefaultExpenseRowContextMenuProps) {
  return (
    <ContextMenu
      entityName="cost category"
      open={canEdit ? { onSelect: onEdit } : false}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <Copy />
          Copy
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(expense.label, "Cost category label");
            }}
          >
            <Clipboard />
            Copy category label
          </ContextMenuItem>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(expense.category, "Cost category");
            }}
          >
            <Clipboard />
            Copy category
          </ContextMenuItem>
          <ContextMenuItem
            disabled={expense.cost === null}
            onSelect={() => {
              void copyToClipboard(String(expense.cost ?? ""), "Cost amount");
            }}
          >
            <Clipboard />
            Copy cost amount
          </ContextMenuItem>
        </ContextMenuSubContent>
      </ContextMenuSub>
    </ContextMenu>
  );
}
